import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PublisherResource, publishersGet2 } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Publisher = Omit<PublisherResource, 'partner' | 'congregation'> & {
  partner?: { firstName: string; lastName: string; id: number } | null;
  congregation: number;
};

export const usePublisher = (
  id: number,
  expand?: string[],
  options: Omit<UseQueryOptions<Publisher, unknown>, 'queryKey'> = {}
) =>
  useQuery({
    queryFn: async () => {
      const publisher = await extractData(
        publishersGet2({
          path: { id },
          query: { expand },
          responseType: 'json',
        })
      );
      return publisher as unknown as Publisher;
    },
    queryKey: ['publishers', id, expand],
    ...options,
  });
